import Vue from 'vue'
import Vuex from 'vuex'
import store from '../store'
const fb = require('../firebaseConfig.js')

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
  //store.commit('setCurrentUser', user)
  //store.dispatch('fetchUserProfile')
  user
  // realtime updates from our posts collection
  fb.winesCollection.onSnapshot(querySnapshot => {

    // add new posts to hiddenPosts array after initial load
    
    let winesArray = []

    querySnapshot.forEach(doc => {
        let wine = doc.data()
        wine.id = doc.id
        winesArray.push(wine)
    })

    store.commit('setWines', winesArray)
  })
  fb.blogsCollection.onSnapshot(querySnapshot => {

    // add new posts to hiddenPosts array after initial load
    
    let blogsArray = []

    querySnapshot.forEach(doc => {
        let blog = doc.data()
        blog.id = doc.id
        blogsArray.push(blog)
    })

    store.commit('setBlogs', blogsArray)
  })
  fb.categoriesCollection.orderBy("nr").onSnapshot(querySnapshot => {

    // add new posts to hiddenPosts array after initial load
    
    let categoriesArray = []

    querySnapshot.forEach(doc => {
        let category = doc.data()
        category.id = doc.id
        categoriesArray.push(category)
    })

    store.commit('setCategories', categoriesArray)
  })
  fb.monthsCollection.onSnapshot(querySnapshot => {

    // add new posts to hiddenPosts array after initial load
    
    let monthsArray = []

    querySnapshot.forEach(doc => {
        let months = doc.data()
        months.id = doc.id
        monthsArray.push(months)
    })

    store.commit('setMonths', monthsArray)
  })
  fb.countriesCollection.onSnapshot(querySnapshot => {

    // add new posts to hiddenPosts array after initial load
    
    let countriesArray = []

    querySnapshot.forEach(doc => {
        let countries = doc.data()
        countries.id = doc.id
        countriesArray.push(countries)
    })

    store.commit('setCountries', countriesArray)
  })
  fb.messagesCollection.onSnapshot(querySnapshot => {

    // add new posts to hiddenPosts array after initial load
    
    let messagesArray = []

    querySnapshot.forEach(doc => {
        let messages = doc.data()
        messages.id = doc.id
        messagesArray.push(messages)
    })

    store.commit('setMessages', messagesArray)
  })
  fb.ratingsCollection.onSnapshot(querySnapshot => {

    // add new posts to hiddenPosts array after initial load
    
    let ratingsArray = []

    querySnapshot.forEach(doc => {
        let ratings = doc.data()
        ratings.id = doc.id
        ratingsArray.push(ratings)
    })

    store.commit('setRatings', ratingsArray)
  })
  fb.grapesCollection.onSnapshot(querySnapshot => {

    // add new posts to hiddenPosts array after initial load
    
    let grapesArray = []

    querySnapshot.forEach(doc => {
        let grapes = doc.data()
        grapes.id = doc.id
        grapesArray.push(grapes)
    })

    store.commit('setGrapes', grapesArray)
  })
  fb.adsCollection.onSnapshot(querySnapshot => {

    // add new posts to hiddenPosts array after initial load
    
    let adsArray = []
    let currentHomeTopAd
    let currentHomeBottomAd
    let currentCatalogTopAd
    let currentWineTopAd
    let currentBlogTopAd
    let currentFoodTopAd
    let currentFoodBottomAd
    let currentContactTopAd
    /* let currentTopAd
    let currentBottomAd
    let currentWineAd */

    querySnapshot.forEach(doc => {
        let ads = doc.data()
        let now = new Date()
        if (Date.parse(ads.startDate) < now && Date.parse(ads.endDate) > now) {
          /* HOME PAGE ADS */
          if (ads.adType == "top" && ads.page == "home") currentHomeTopAd = ads
          if (ads.adType == "bottom" && ads.page == "home") currentHomeBottomAd = ads

          /* CATALOG ADS */
          if (ads.adType == "top" && ads.page == "catalog") currentCatalogTopAd = ads

          /* WINE INFO ADS */
          if (ads.adType == "top" && ads.page == "wine") currentWineTopAd = ads

          /* BLOG ADS */
          if (ads.adType == "top" && ads.page == "blog") currentBlogTopAd = ads

          /* FOOD ADS */
          if (ads.adType == "top" && ads.page == "food") currentFoodTopAd = ads
          if (ads.adType == "bottom" && ads.page == "food") currentFoodBottomAd = ads

          /* CONTACT ADS */
          if (ads.adType == "top" && ads.page == "contact") currentContactTopAd = ads
        }
        ads.id = doc.id
        adsArray.push(ads)
    })
    if (currentHomeTopAd) store.commit('setCurrentHomeTopAd', currentHomeTopAd)
    if (currentHomeBottomAd) store.commit('setCurrentHomeBottomAd', currentHomeBottomAd)
    if (currentCatalogTopAd) store.commit('setCurrentCatalogTopAd', currentCatalogTopAd)
    if (currentWineTopAd) store.commit('setCurrentWineTopAd', currentWineTopAd)
    if (currentBlogTopAd) store.commit('setCurrentBlogTopAd', currentBlogTopAd)
    if (currentFoodTopAd) store.commit('setCurrentFoodTopAd', currentFoodTopAd)
    if (currentFoodBottomAd) store.commit('setCurrentFoodBottomAd', currentFoodBottomAd)
    if (currentContactTopAd) store.commit('setCurrentContactTopAd', currentContactTopAd)
    
    store.commit('setAds', adsArray)
  })
})


export default new Vuex.Store({
  state: {
    wines: [],
    blogs: [],
    categories: [],
    months: [],
    countries: [],
    messages: [],
    grapes: [],
    ads: [],
    currentHomeTopAd: null,
    currentHomeBottomAd: null,
    currentCatalogTopAd: null,
    currentWineTopAd: null,
    currentBlogTopAd: null,
    currentFoodTopAd: null,
    currentFoodBottomAd: null,
    currentContactTopAd: null,
  },
  mutations: {
    setWines(state, val) {
      state.wines = val
    },
    setBlogs(state, val) {
      state.blogs = val
    },
    setCategories(state, val) {
      state.categories = val
    },
    setMonths(state, val) {
      state.months = val
    },
    setCountries(state, val) {
      state.countries = val
    },
    setMessages(state, val) {
      state.messages = val
    },
    setRatings(state, val) {
      state.ratings = val
    },
    setGrapes(state, val) {
      state.grapes = val
    },
    setAds(state, val) {
      state.ads = val
    },
    setCurrentHomeTopAd(state, val) {
      state.currentHomeTopAd = val
    },
    setCurrentHomeBottomAd(state, val) {
      state.currentHomeBottomAd = val
    },
    setCurrentCatalogTopAd(state, val) {
      state.currentCatalogTopAd = val
    },
    setCurrentWineTopAd(state, val) {
      state.currentWineTopAd = val
    },
    setCurrentBlogTopAd(state, val) {
      state.currentBlogTopAd = val
    },
    setCurrentFoodTopAd(state, val) {
      state.currentFoodTopAd = val
    },
    setCurrentFoodBottomAd(state, val) {
      state.currentFoodBottomAd = val
    },
    setCurrentContactTopAd(state, val) {
      state.currentContactTopAd = val
    },
  },
  actions: {
    clearData({ commit }) {
      commit('setWines', null)
      commit('setBlogs', null)
      commit('setCategories', null)
      commit('setMonths', null)
      commit('setCountries', null)
      commit('setMessages', null)
      commit('setRatings', null)
      commit('setGrapes', null)
      commit('setAds', null)
      commit('currentHomeTopAd', null)
      commit('currentHomeBottomAd', null)
      commit('currentCatalogTopAd', null)
      commit('currentWineTopAd', null)
      commit('currentBlogTopAd', null)
      commit('currentFoodTopAd', null)
      commit('currentFoodBottomAd', null)
      commit('currentContactTopAd', null)
    }
  },
  getters: {
    getWines: state => {
      return state.wines
    }
  },
  modules: {
  }
})
